"use strict";

exports.__esModule = true;
exports.default = void 0;

var _popover = _interopRequireDefault(require("./popover"));

var _popover2 = _interopRequireDefault(require("../../directives/popover/popover"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BPopover: _popover.default
};
var directives = {
  BPopover: _popover2.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components,
    directives: directives
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/popover/index.js
// module id = 254
// module chunks = 43